module.exports = __webpack_public_path__ + "img/38.9cf7adff.jpg";